import { FocusContext } from '@noriginmedia/norigin-spatial-navigation'
import React, { useEffect } from 'react'
import {
  KeyTypeEnum,
  useKeyDown,
} from '../../../../shared/providers/KeyDownProvider'
import FocusableButtonTS from '../../components/FocusableButton/FocusableButtonTS'
import QRCodeGenerator from '../../components/QRCodeGenerator'
// eslint-disable-next-line import/extensions
import StationPassportTitle from '../../components/StationPassportTitle/StationPassportTitle'
import { useHybridFocusable } from '../../hooks/useHybridFocusable'
// eslint-disable-next-line import/extensions
import tts from '../../lib/TTS'
import PassPortUpsellTS from '../PassPortUpsell/PassPortUpsellTS'
import usePassportHandoffScreen from './hooks'

const FOCUS_KEY = 'PASSPORT_HANDOFF_SCREEN'

function PassportHandoffScreen() {
  const { ref, focusKey, focusSelf } = useHybridFocusable({
    focusKey: FOCUS_KEY,
  })

  const {
    stationDisplayName,
    qrUrl,
    displayUrl,
    isQrUrlValid,
    handleGoBack,
    handleWhatIsPassport,
  } = usePassportHandoffScreen()

  useEffect(() => {
    window.focusedComponent = {} as any
    window.focusedComponent.handleBySpatialNavigation = true
    return () => {
      window.focusedComponent.handleBySpatialNavigation = false
    }
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      focusSelf()
    }, 100)
    return () => clearTimeout(timer)
  }, [focusSelf])

  useKeyDown(KeyTypeEnum.Back, () => {
    handleGoBack()
  })

  if (!isQrUrlValid) {
    return <PassPortUpsellTS />
  }

  const buttonSpeaker = (text: string) => {
    tts.stopRead()
    tts.addTextToRead(text)
  }

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className="passport-handoff-screen">
        <div className="passport-handoff-screen__content">
          <StationPassportTitle
            className="passport-handoff-screen__header"
            stationTitle={stationDisplayName}
          />

          <p className="passport-handoff-screen__description">
            {'Donate to become a member of '}
            {stationDisplayName}
            {' and access Passport.'}
            <br />
            Passport is a member benefit that lets you stream more of your
            favorite PBS shows.
          </p>

          <h2 className="passport-handoff-screen__donate-heading">
            Donate & Start Watching
          </h2>

          <p className="passport-handoff-screen__visit-text">
            {'Visit '}
            <span className="passport-handoff-screen__url">{displayUrl}</span>
          </p>

          <div className="passport-handoff-screen__separator">
            <span className="passport-handoff-screen__separator-line" />
            <span className="passport-handoff-screen__separator-text">OR</span>
            <span className="passport-handoff-screen__separator-line" />
          </div>

          <p className="passport-handoff-screen__scan-text">
            Scan the QR code with your device&apos;s camera
          </p>

          <div className="passport-handoff-screen__qr">
            <QRCodeGenerator
              text={qrUrl}
              width={300}
              bgColor="#ffffff"
              fgColor="#2035C5"
              errorCorrectionLevel="L"
              margin={2}
              className="passport-handoff-screen__qr-image"
            />
          </div>

          <div className="passport-handoff-screen__buttons">
            <div className="passport-handoff-screen__button-container">
              <FocusableButtonTS
                focusKey="passport-go-back-button"
                onEnterPress={handleGoBack}
                onFocus={() => buttonSpeaker('Focused on Go Back')}
                className="passport-handoff-screen__btn"
                stealFocus
              >
                Go Back
              </FocusableButtonTS>
            </div>

            <div className="passport-handoff-screen__button-container">
              <FocusableButtonTS
                focusKey="passport-what-is-button"
                onEnterPress={handleWhatIsPassport}
                onFocus={() => buttonSpeaker('Focused on What is Passport?')}
                className="passport-handoff-screen__btn"
              >
                What is Passport?
              </FocusableButtonTS>
            </div>
          </div>
        </div>
      </div>
    </FocusContext.Provider>
  )
}

export default PassportHandoffScreen
